<script setup>

import QuestionComponent from '@/components/CompiledPoll/QuestionComponent.vue'

defineProps(['handleAnswer', 'compiledPoll', 'questionGroup']);
</script>

<template>
  <div>
    <h4>Domande</h4>
    <div v-for="(question) in questionGroup['questions']" :key="question.id">
      <question-component :compiled-poll="compiledPoll" :handle-answer="handleAnswer" :question="question"></question-component>
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>
